export const concatBsi = (buy: boolean, sale: boolean, inventory: boolean): string => {
    return `${buy ? "B" : ""}${sale ? "S" : ""}${inventory ? "I" : ""}`
}